import * as React from 'react';
import {Mutation} from 'react-apollo';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Assignables} from 'nutshell-core/assignables';
import type {Assignable} from 'nutshell-core/types';

import {AssigneeSelect} from 'shells/assignee-select/assignee-select';

import type {
    Lead as LeadFragment,
    UpdateLeadAssignee as UpdateLeadAssigneeMutation,
    UpdateLeadAssigneeVariables as UpdateLeadAssigneeMutationVariables,
    GetLead as GetLeadQuery,
} from 'nutshell-graphql-types';

import ASSIGN_LEAD from '../../../shared/graphql/mutations/update-lead-assignee.graphql';
import GET_LEAD from '../../../shared/graphql/queries/get-lead.graphql';

import type {NutshellState} from '../../../../../store';
import {useGetSessionUser} from '../../../../core/use-get-session-user';

class UpdateAssigneeMutation extends Mutation<
    UpdateLeadAssigneeMutation,
    UpdateLeadAssigneeMutationVariables
> {}

type OwnProps = {
    lead: LeadFragment;
    showTooltip?: boolean;
};
type StateProps = {
    assignables: Assignable[];
};
type RoutedProps = OwnProps & ContextRouter;
type Props = RoutedProps & StateProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        // @ts-expect-error
        assignables: Assignables.getAllEnabled(state),
    };
}

function AssigneeButtonComponent(props: Props) {
    const {user} = useGetSessionUser();
    const canAssignEntities = Boolean(user && user.permissions.canAssignEntities);

    return (
        <UpdateAssigneeMutation mutation={ASSIGN_LEAD}>
            {(assignLead, {loading}) => (
                <AssigneeSelect
                    inputId='AssigneePicker'
                    placeholder='Assign this lead…'
                    isDisabled={loading || !canAssignEntities}
                    onChange={(assigneeId) => {
                        const optimisticNewAssignee = props.assignables.find(
                            // @ts-expect-error
                            (assignee) => assignee.id === assigneeId
                        );

                        assignLead({
                            variables: {lead: {id: props.lead.id, assigneeId: assigneeId}},
                            optimisticResponse: {
                                // @ts-expect-error
                                __typename: 'Mutation',
                                assignLead: {
                                    __typename: 'AssignLeadPayload',
                                    lead: props.lead
                                        ? {
                                              ...props.lead,
                                              assignee: optimisticNewAssignee
                                                  ? {
                                                        ...optimisticNewAssignee,
                                                        __typename:
                                                            optimisticNewAssignee.type === 'users'
                                                                ? 'User'
                                                                : 'Team',
                                                    }
                                                  : null,
                                          }
                                        : null,
                                    errors: null,
                                },
                            },
                            update: (proxy, mutationResult) => {
                                if (
                                    mutationResult &&
                                    mutationResult.data &&
                                    mutationResult.data.assignLead &&
                                    !mutationResult.data.assignLead.lead &&
                                    mutationResult.data.assignLead.errors &&
                                    mutationResult.data.assignLead.errors ===
                                        'You don’t have permission to view that lead anymore!'
                                ) {
                                    props.history.replace('/leads');

                                    return;
                                }

                                const newAssignee =
                                    mutationResult &&
                                    mutationResult.data &&
                                    mutationResult.data.assignLead &&
                                    mutationResult.data.assignLead.lead &&
                                    mutationResult.data.assignLead.lead.assignee;
                                if (!newAssignee) return;

                                const cacheResult: GetLeadQuery | null | undefined =
                                    proxy.readQuery({
                                        query: GET_LEAD,
                                        variables: {id: props.lead.id},
                                    });

                                if (!cacheResult) return;

                                const oldLead = cacheResult.lead;

                                proxy.writeQuery({
                                    query: GET_LEAD,
                                    data: {
                                        lead: {
                                            ...oldLead,
                                            assignee: newAssignee,
                                        },
                                    },
                                });
                            },
                        });
                    }}
                    value={props.lead.assignee && props.lead.assignee.id}
                    options={props.assignables}
                    showTooltip={props.showTooltip}
                />
            )}
        </UpdateAssigneeMutation>
    );
}

// @ts-expect-error
const connector = connect<Props, RoutedProps, _, _, _, _>(mapStateToProps);
// @ts-expect-error
export const AssigneeButton = withRouter<OwnProps>(connector(AssigneeButtonComponent));
